var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8258 11.4788C19.8258 6.86841 16.0883 3.13092 11.4779 3.13092C6.86743 3.13092 3.12995 6.86841 3.12995 11.4788C3.12995 16.0893 6.86743 19.8267 11.4779 19.8267C13.7834 19.8267 15.8693 18.8939 17.3811 17.3821C18.8929 15.8703 19.8258 13.7843 19.8258 11.4788ZM21.9127 11.4788C21.9127 13.9841 21.027 16.2828 19.5557 18.0811L22.6505 21.1759L22.7219 21.2554C23.0561 21.6653 23.0326 22.2695 22.6505 22.6515C22.2685 23.0335 21.6643 23.0571 21.2545 22.7228L21.175 22.6515L18.0802 19.5567C16.2819 21.028 13.9831 21.9137 11.4779 21.9137C5.71483 21.9137 1.04297 17.2419 1.04297 11.4788C1.04297 5.7158 5.71483 1.04395 11.4779 1.04395C17.2409 1.04395 21.9127 5.7158 21.9127 11.4788Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b59eee2a0e734a55e781f46acf8ea09a.svg";
export { ForwardRef as ReactComponent };